import { render, staticRenderFns } from "./DocumentProductionList.vue?vue&type=template&id=4fd5f765&scoped=true"
import script from "./DocumentProductionList.vue?vue&type=script&lang=js"
export * from "./DocumentProductionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd5f765",
  null
  
)

export default component.exports